import { useState, useEffect } from "react";
import Table from "../../components/Table/Table";
import { TableSearch } from "../../components/Table/TableActions";
import Modal from "../../components/Modal/index";
import { Icon } from "@iconify/react";
import { httprequest } from "../../data/api";
import { toast, ToastContainer } from "react-toastify";
import Layout from "../../components/Layout/Layout";
import PageTitle from "../../components/PageTitle/PageTitle";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import Button from "../../components/Button/Button";
import { Grid } from "@mui/material";
import InputGroup from "../../components/FormComponent/InputGroup";
import SelectGroup from "../../components/FormComponent/SelectGroup";

const EMPLOYEE_ENDPOINT = "/admin/v1/superusers";
const ROLES_ENDPOINT = "/admin/v1/super-user-roles";
const USER_ENDPOINT = "/admin/v1/auth/invite";

const AllEmployees = () => {
  const [searchResult, setSearchResult] = useState([]);
  const [AllEmployeesData, setAllEmployeesData] = useState([]);
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    job_title: "",
    role: ""
  });
  const [isLoading, setIsLoading] = useState(false);
  const [rolesData, setRolesData] = useState([]);
  const [currentRow, setCurrentRow] = useState({});
  const [deleteModal, setDeleteModal] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const { first_name, last_name, email, job_title, role } = formData;

  const [createModal, setCreateModal] = useState(false);

  const handleOpenCreateModal = () => setCreateModal(true);
  const handleCloseCreateModal = () => setCreateModal(false);

  const getEmployeeData = () => {
    httprequest
      .get(`${EMPLOYEE_ENDPOINT}`)
      .then((res) => {
        setAllEmployeesData(res?.data?.data);
        setSearchResult(res?.data?.data);
      })
      .catch((err) => {
        toast.error(err?.response?.data);
      });
  };

  const handleAddUser = async () => {
    const payload = {
      first_name,
      last_name,
      email,
      job_title,
      role
    };

    try {
      setIsLoading(true);
      const response = await httprequest.post(USER_ENDPOINT, payload);
      toast.success(response.data.message);
      handleCloseCreateModal();
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          "Failed to add user. Please try again."
      );
    } finally {
      setIsLoading(false);
    }
  };

  const getRoles = () => {
    httprequest
      .get(`${ROLES_ENDPOINT}`)
      .then((res) => {
        const updatedEmployee = res?.data?.data?.filter(
          (newrole) => newrole?.role_type !== "school_admin" &&
            newrole?.role_type !== "guardian" &&
            newrole?.role_type !== "student"
        );
        setRolesData(updatedEmployee);
      })
      .catch(() => {});
  };

  const handleDeleteEmployee = () => {
    setIsDeleting(true);
    httprequest
      .delete(`/admin/v1/superuser/${currentRow?.id}`)
      .then((res) => {
        setIsDeleting(false);
        toast.success(res?.data?.message);
        getEmployeeData();
      })
      .catch((err) => {
        setIsDeleting(false);
        toast.error(err?.response?.data.message);
      });
  };

  const handleDeleteModal = (row) => {
    setCurrentRow(row);
    setDeleteModal(!deleteModal);
  };

  const handleCloseDeleteModal = () => {
    setDeleteModal(false);
  };
  const handleCreateChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const columns = [
    // {
    //   name: "Code",
    //   selector: row => row?.code
    // },
    {
      name: "Name",
      // eslint-disable-next-line prefer-template
      selector: (row) => row?.first_name + " " + row?.last_name
    },
    {
      name: "Email Address",
      selector: (row) => row?.email
    },
    {
      name: "Job Title",
      selector: (row) => row?.job_title
    },
    {
      name: "Role",
      selector: (row) => row?.role?.name
    },
    {
      name: "",
      center: true,
      sortable: false,
      cell: (row) => (
        <div key={row?.id} className="table-action-container">
          {/* <Link to={`/schools/users/${row?.id}`} className="table-action-icon">
            <Icon icon="fluent:eye-16-regular" />
          </Link> */}
          {/* <Link to={`/schools/users/${row?.employee_id}`} className="table-action-icon">
            <Icon icon="heroicons:pencil-square-solid" />
          </Link> */}
          <button
            onClick={() => handleDeleteModal(row)}
            className="table-action-icon"
            key={row.id}
          >
            {row?.is_active === true ? (
              <div className="delete-icon">
                <Icon icon="mingcute:delete-2-line" />
              </div>
            ) : (
              <div className="approve-icon">
                <Icon icon="mdi:checkbox-marked-circle-outline" />
              </div>
            )}
          </button>
        </div>
      )
    }
  ];

  // --| Filter Teacher table using name, email and class
  const handleSearchTeacher = (e) => {
    const { value } = e.target;

    const valArray = value.split(" ");
    // --| Filter data by partial match onchange in the search input box
    const result = AllEmployeesData?.filter((data) => valArray?.every(
      (word) => data?.first_name?.toLowerCase().includes(word.toLowerCase()) ||
          data?.last_name?.toLowerCase().includes(word.toLowerCase()) ||
          data?.email?.toLowerCase().includes(word.toLowerCase())
    )
    );
    setSearchResult(result);
  };

  useEffect(() => {
    getEmployeeData();
    setSearchResult();
    getRoles();
  }, []);

  return (
    <Layout
      children={
        <>
          <PageTitle
            title="User"
            button={
              <Button
                variant="primary"
                buttonSize="fluid"
                color="btndefault"
                subtitle="See list of users"
                onClick={handleOpenCreateModal}
                buttonName={
                  <div className="flex align-items-center gap-5">
                    <span>
                      <AddCircleOutlineIcon />
                    </span>
                    Add a new User
                  </div>
                }
              />
            }
          />
          <Table
            data={searchResult}
            columns={columns}
            subHeader={true}
            pagination
            subHeaderComponent={
              <TableSearch
                placeholder="Search here..."
                searchTableFunc={handleSearchTeacher}
              />
            }
          />
          <Modal
            title="Add User"
            subtitle={
              <div>
                Add this user to your school. Once added, they will receive an
                email to create their password.
              </div>
            }
            modalContent={
              <>
                <Grid container spacing={2} className="input-padding">
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <InputGroup
                      label="First Name"
                      margin="normal"
                      inputType="text"
                      inputName="first_name"
                      inputValue={first_name}
                      onChange={handleCreateChange}
                      required
                    />
                  </Grid>
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <InputGroup
                      label="Last Name"
                      margin="normal"
                      inputType="text"
                      inputName="last_name"
                      inputValue={last_name}
                      onChange={handleCreateChange}
                      required
                    />
                  </Grid>
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <InputGroup
                      label="Email Address"
                      margin="normal"
                      inputType="email"
                      inputName="email"
                      inputValue={email}
                      onChange={handleCreateChange}
                      required
                    />
                  </Grid>
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <InputGroup
                      label="Job Title"
                      margin="normal"
                      inputType="text"
                      inputName="job_title"
                      inputValue={job_title}
                      onChange={handleCreateChange}
                      required
                    />
                  </Grid>
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <SelectGroup
                      label="Role"
                      required
                      children={
                        <select
                          onChange={handleCreateChange}
                          value={role}
                          name="role"
                        >
                          <option value="">--- Select ---</option>
                          {rolesData?.map((role) => {
                            return (
                              <option key={role?.role_id} value={role?.id}>
                                {role?.name}
                              </option>
                            );
                          })}
                        </select>
                      }
                    />
                  </Grid>
                </Grid>
              </>
            }
            modalFooter={
              <>
                <Button
                  variant="primary"
                  buttonName="Add User"
                  buttonSize="full"
                  color="btndefault"
                  onClick={handleAddUser}
                  isLoading={isLoading}
                />
              </>
            }
            isopen={createModal}
            closeModal={handleCloseCreateModal}
          />
          <Modal
            title={"Off board User"}
            subtitle={
              <div>
                Are you sure you want to off board
                <span className="modal-name-highlight">
                  {" "}
                  {`${currentRow?.last_name} ${currentRow?.first_name}`}
                </span>
                ? If deleted, the employee will no longer have access to this
                platform.
              </div>
            }
            modalContent={<></>}
            modalFooter={
              <>
                {
                  <Button
                    variant="danger"
                    onClick={handleDeleteEmployee}
                    isLoading={isDeleting}
                    buttonName="Off board User"
                    buttonSize="full"
                    color="btndefault"
                  />
                }
              </>
            }
            isopen={deleteModal}
            closeModal={handleCloseDeleteModal}
          />
          <ToastContainer />
        </>
      }
    />
  );
};

export default AllEmployees;
